import {
  CfdMicroservice,
  getCrossFarmDashboardMicroservice,
} from '@xarvio/frontend-core-platform/lib/services/cfdService';
import { AppFeatureName } from '@xarvio/frontend-core-state/lib/featureFlags/utils';
import { getPageUrlDic, Page } from '../AppRouter/routes';
import api from '../utils/API';
import { isFeatureEnabled } from '../components/shared/FeatureToggle/utils';

type CfdV2Rollout = {
  featureFlag: AppFeatureName;
  pages: Page[];
  homeAggregations: string[];
};

const pageUrls = getPageUrlDic({});

const CFD_V2_ROLLOUTS: CfdV2Rollout[] = [
  {
    featureFlag: 'HF_CFD_V2',
    pages: [
      Page.CROSS_FARM_DASHBOARD_CROP_DETAILS,
      Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS_OVERVIEW,
      Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__COMMERCIAL_PARTNER,
      Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__SEASON_COORDINATOR,
      Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__AGRONOMIST,
      Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__CONTRACTOR,
    ],
    homeAggregations: ['hfStats'],
  },
];

export const resolveCrossFarmDashboardMicroservice = (
  homeAggregation?: string,
): CfdMicroservice => {
  if (typeof window === 'undefined') return 'cross-farm-dashboard';

  const { pathname } = window.location;
  const rollout = CFD_V2_ROLLOUTS.find((rollout) =>
    pathname.endsWith(pageUrls[Page.CROSS_FARM_DASHBOARD])
      ? homeAggregation !== undefined &&
        rollout.homeAggregations.includes(homeAggregation)
      : rollout.pages.some((page) => pathname.endsWith(pageUrls[page])),
  );

  return rollout && isFeatureEnabled(rollout.featureFlag)
    ? 'cross-farm-dashboard-v2'
    : 'cross-farm-dashboard';
};

type RequestOptions = {
  signal?: AbortSignal;
  microservice?: CfdMicroservice;
};

export interface CfdElkResponse<THitSource = any, TInnerHits = never> {
  hits: {
    hits: { _id: string; _source: THitSource; inner_hits?: TInnerHits }[];
    total: { value: number; relation: string };
  };
}

export const requestDataCFD = <TResult = any>(
  query: object,
  includeClosedCS: boolean = false,
  options?: RequestOptions,
) => {
  const { microservice = getCrossFarmDashboardMicroservice(), ...apiOptions } =
    options ?? {};
  let resource = '_search';

  if (isFeatureEnabled('BASF_SALES_SCOPE_CFD')) {
    resource = '_scoped_search';
  }

  const url = includeClosedCS
    ? `${microservice}/${resource}?includeClosedCropSeasons=true`
    : `${microservice}/${resource}`;

  return api.post<void, TResult>(url, JSON.stringify(query), apiOptions);
};

export const requestDataHFCFD = <TResult = any>(query: object) => {
  const microservice = `${getCrossFarmDashboardMicroservice()}/hf`;
  const resource = '_search';

  return api.post<void, TResult>(
    `${microservice}/${resource}`,
    JSON.stringify(query),
  );
};

export const requestDataSustainabilityCFD = <TResult = any>(query: object) => {
  const microservice = `${getCrossFarmDashboardMicroservice()}/sustainability`;
  const resource = '_search';

  return api.post<void, TResult>(
    `${microservice}/${resource}`,
    JSON.stringify(query),
  );
};

export default {
  requestDataCFD,
  requestDataHFCFD,
};
